export const CustomerTableHeaders=[
    {
        Header:'Name',
        accessor:'name'
    },
    {
        Header:'Lastname',
        accessor:'lastname'
    },
    {
        Header:'Phone',
        accessor:'phone'
    },
    {
        Header:'Address',
        accessor:'address'
    }
]